import React, { Component } from 'react';
import Calendar32 from '@carbon/icons-react/lib/calendar/32';
import Thumbnail32 from '@carbon/icons-react/lib/thumbnail--2/32';
import Task32 from '@carbon/icons-react/lib/task/32';
import Help32 from '@carbon/icons-react/lib/help/32';
import { Link, } from 'react-router-dom'

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div className="bx--grid max-width">
                <div className="bx--row row-eq-height">
                    <div className="bx--row row-tasks">
                        <Link to={`/dailytasks`}>
                            <div className="heading-container">
                                <Task32 />
                                <h1 className="heading">Daily Tasks</h1>
                                <h1 className="subheading">My pending daily activities</h1>
                            </div>
                        </Link>
                    </div>
                    <div className="bx--row row-functions">
                        <Link to={`/modules`}>
                            <div className="heading-container">
                                <Thumbnail32 />
                                <h1 className="heading">Modules</h1>
                                <h1 className="subheading">Incident, Audit, Report, HOC, Inspection Management, Emergency Drill, Training, Insight Data, Group Dashboard</h1> 
                            </div>
                        </Link>
                    </div>
                    <div className="bx--row row-utilities">
                        <Link to={`/support`}>
                            <div className="heading-container">
                                <Help32 />
                                <h1 className="heading">Support</h1>
                                <h1 className="subheading">Do you need help?</h1>
                            </div>
                        </Link>
                    </div>
                </div>

            </div>
        );
    }
}
